import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { filter, Subscription } from 'rxjs';
import { LoadingService } from '../../services/loading.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit {
    subscriptions: Subscription = new Subscription();

    public isLoading: boolean = false;

    constructor(private loadingService: LoadingService, private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.subscriptions.add(
            this.loadingService.resetDataSubject.pipe(filter((x) => x.loader)).subscribe(({ isLoading }) => {
                this.isLoading = isLoading;
                this.cdr.detectChanges();
            })
        );
    }
}
